import * as React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import Landing from '../components/landing/Landing';
import QrScanner from '../pages/Landing';
import CustomerCare from '../pages/customercare';
import Home from '../pages/home';
import HomePage from '../pages/home/HomePage';
import LMRSignUp from '../pages/lmrsignup';
import Offers from '../pages/offers';
import UnlockedOffers from '../pages/unlockedoffers';
import LMRotp from '../pages/lmrotp';
import {
  AuthorizedRoute,
  GuestRoute,
  AlternativeRoute,
  EmployeeRoutes,
} from './routesTypes';
import ProfileUpdate from '../pages/updateprofile';
import MissingSizes from '../pages/missingsizes/missingsizebarcode';
import SelectSize from '../pages/missingsizes/selectmissingsize';
import SelectColor from '../pages/missingsizes/selectcolor';
import NotifyScreen from '../pages/missingsizes/notify';
import LMRrewards from '../pages/lmrrewards';
import TermsAndCondition from '../pages/termscondition';
import ContactUs from '../pages/contactus';
import LMRpromotions from '../pages/lmrpromo';
import Payment from '../pages/checkout/payment';
import ConfirmCheckout from '../pages/checkout/confirm';
import StoreLocation from '../pages/lmremployee/employeestorelocation';
import EmployeeLocation from '../pages/lmremployee/employeeloacation';
import EmployeeSignIn from '../pages/lmremployee/employeesignin';
import EmployeeTempPassword from '../pages/lmremployee/employeetemppassword';
import EmployeeResetPassword from '../pages/lmremployee/employeeresetpassword';
import PosThankyou from '../pages/checkout/confirm/PosThankyou';
import {
  CONTACT_US_ROUTE_PATH,
  CUSTOMER_CARE_ROUTE_PATH,
  HOME_ROUTE_PATH,
  LOGIN_ROUTE_PATH,
  OFFERS_ROUTE_PATH,
  PROFILE_UPDATE_ROUTE_PATH,
  REWARDS_ROUTE_PATH,
  SIGNUP_ROUTE_PATH,
  TERMS_CONDITIONS_ROUTE_PATH,
  UNLOCKED_OFFERS_ROUTE_PATH,
  MISSING_SIZE_PATH,
  SELECT_SIZE_PATH,
  SELECT_COLOR_PATH,
  NOTIFY_PATH,
  CHECKOUT_PATH,
  LANDING_PATH,
  IN_STORE_PROMOTIONS_PATH,
  SHOPPINGBAG_PATH,
  RESET_PASSWORD,
  STORE_LOCATION,
  LOCATION,
  EMPLOYEE_SIGNIN,
  TEMP_PASSWORD,
  TODAYS_ORDER_PATH,
  PAYMENT_PATH,
  MATCHPRICE_PATH,
  CONFIRM_PATH,
  THANKYOU,
  ELITE_PATH,
  SPLASH_PATH,
  FEEDBACK_PATH,
  SCAN_PRODUCT,
  PAYMENT_ERROR,
  PROCESS_PAYMENT_PATH,
  INVALID_ORDER_PATH
} from './route-constants';
import CheckoutHome from '../pages/checkout';
import CheckoutHomePage from '../pages/checkout/CheckoutHomePage';
import ShoppingBag from '../pages/checkout/shoppingbag';
import TodaysOrders from '../pages/todaysorders';
import MatchPrice from '../pages/checkout/matchPrice';
import ThankYou from '../pages/checkout/confirm/Thankyou';
import Elite from '../pages/elite';
import Splash from '../components/splash/Splash';
import LMRfeedback from '../pages/checkout/feedback';
import LMRscanProduct from '../pages/checkout/scanProduct';
import PaymentError from '../pages/checkout/payment/PaymentError';
import ProcessPayment from '../pages/checkout/payment/ProcessPayment';
import InvalidOrder from '../pages/checkout/confirm/InvalidOrder';

const Router: React.FC = () => {
  return (
    <Switch>
      <Route
        path={HOME_ROUTE_PATH}
        render={({match: {path}}) => (
          <Home>
            <Switch>
              <AuthorizedRoute exact path={path + '/'} component={HomePage} />
              <AuthorizedRoute
                path={`${path}${OFFERS_ROUTE_PATH}`}
                component={Offers}
              />
              <AuthorizedRoute
                path={`${path}${UNLOCKED_OFFERS_ROUTE_PATH}`}
                component={UnlockedOffers}
              />
              <AuthorizedRoute
                path={`${path}${CUSTOMER_CARE_ROUTE_PATH}`}
                component={CustomerCare}
              />
              <AuthorizedRoute
                path={`${path}${PROFILE_UPDATE_ROUTE_PATH}`}
                component={ProfileUpdate}
              />
              <AuthorizedRoute
                path={`${path}${REWARDS_ROUTE_PATH}`}
                component={LMRrewards}
              />
              <AuthorizedRoute
                path={`${path}${TERMS_CONDITIONS_ROUTE_PATH}`}
                component={TermsAndCondition}
              />
              <AuthorizedRoute
                path={`${path}${CONTACT_US_ROUTE_PATH}`}
                component={ContactUs}
              />
              <AuthorizedRoute
                path={`${path}${MISSING_SIZE_PATH}`}
                component={MissingSizes}
              />
              <AuthorizedRoute
                path={`${path}${SELECT_SIZE_PATH}`}
                component={SelectSize}
              />
              <AuthorizedRoute
                path={`${path}${SELECT_COLOR_PATH}`}
                component={SelectColor}
              />
              <AuthorizedRoute
                path={`${path}${NOTIFY_PATH}`}
                component={NotifyScreen}
              />

              <AuthorizedRoute
                path={`${path}${IN_STORE_PROMOTIONS_PATH}`}
                component={LMRpromotions}
              />
              <AuthorizedRoute
                path={`${path}${TODAYS_ORDER_PATH}`}
                component={TodaysOrders}
              />
              <AuthorizedRoute
                path={`${path}${ELITE_PATH}`}
                component={Elite}
              />

              <Redirect exact from={path + '/*'} to={path} />
            </Switch>
          </Home>
        )}
      />

      <Route
        path={CHECKOUT_PATH}
        render={({match: {path}}) => (
          <CheckoutHome>
            <Switch>
              <AuthorizedRoute
                exact
                path={path + '/'}
                component={CheckoutHomePage}
              />
              <AuthorizedRoute
                exact
                path={`${path}${MATCHPRICE_PATH}`}
                component={MatchPrice}
              />
              <AuthorizedRoute
                exact
                path={`${path}${SHOPPINGBAG_PATH}`}
                component={ShoppingBag}
              />
              <AuthorizedRoute
                exact
                path={`${path}${PAYMENT_PATH}`}
                component={Payment}
              />
              <AuthorizedRoute
                exact
                path={`${path}${PROCESS_PAYMENT_PATH}`}
                component={ProcessPayment}
              />
              <AuthorizedRoute
                exact
                path={`${path}${PAYMENT_ERROR}`}
                component={PaymentError}
              />
              <AuthorizedRoute
                exact
                path={`${path}${CONFIRM_PATH}`}
                component={ConfirmCheckout}
              />
              <AuthorizedRoute
                exact
                path={`${path}${FEEDBACK_PATH}`}
                component={LMRfeedback}
              />
              <AuthorizedRoute
                exact
                path={`${path}${SCAN_PRODUCT}`}
                component={LMRscanProduct}
              />
              <AuthorizedRoute
                exact
                path={`${path}${INVALID_ORDER_PATH}`}
                component={InvalidOrder}
              />
              <Redirect exact from={path + '/*'} to={path} />
            </Switch>
          </CheckoutHome>
        )}
      />

      <EmployeeRoutes path={RESET_PASSWORD} component={EmployeeResetPassword} />
      <EmployeeRoutes path={STORE_LOCATION} component={StoreLocation} />
      <EmployeeRoutes path={LOCATION} component={EmployeeLocation} />
      <EmployeeRoutes path={EMPLOYEE_SIGNIN} component={EmployeeSignIn} />
      <EmployeeRoutes path={TEMP_PASSWORD} component={EmployeeTempPassword} />

      <Route path={LANDING_PATH} component={QrScanner} />
      <GuestRoute path={LANDING_PATH} component={QrScanner} />
      <GuestRoute path={LOGIN_ROUTE_PATH} component={LMRotp} />

      <EmployeeRoutes path={THANKYOU} component={PosThankyou} />

      <AlternativeRoute path={SIGNUP_ROUTE_PATH} exact component={LMRSignUp} />
      <GuestRoute path={SPLASH_PATH} component={Splash} />
      <GuestRoute path="/" component={Landing} />

      <Redirect to="/" />
    </Switch>
  );
};

export default Router;
